<template>
    <v-card>
        <v-form ref="customerLogReportForm" v-model="isValid">
            <v-card-text>
                <v-card-title>Customer Log Report</v-card-title>
                <v-container class="pb-0" fluid>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >Close</v-btn
                        >
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >Generate</v-btn
                        >
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
//import dateToString from "../../helpers/dateToString"
export default {
    components: {
        //
    },
    data() {
        return {
            isValid: null,
            isLoading: null,
            isSaving: null,
            inputDateFrom: null,
            inputDateTo: null,

            dateMenuFrom: false,
            dateMenuTo: false,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: (v) => !!v || "required",
            requiredRuleNum: (v) => !!v || v === 0 || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
        };
    },

    methods: {
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.customerLogReportForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;
                this.$store
                    .dispatch("customers/customerlogreport", {
                        fromDate: this.inputDateFrom,
                        toDate: this.inputDateTo,
                    })
                    .then(
                        (fileId) => {
                            this.notify("Downloading...", "success");

                            this.$store.dispatch("files/get", {
                                fileId: fileId,
                                namePrefix:
                                    "CustomerLogReport",
                            });
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
    },
};
</script>

<style lang="stylus" scoped></style>